export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/modules/Home'),
    meta: {
      layout: 'frontend'
    }
  }, 
 
  {
    path: '*',
    name: '404',
    component: () => import('@/views/Error'),
    meta: {
      layout: 'base'
    }
  }
]